import { config } from "tsi-common-react/src/config";
import { strings } from "tsi-common-react/src/localization";
import { t } from "ttag";

config.update({
    ENABLE_CHECKOUT_CAPTCHA: true,
    ENABLE_EMAIL_SIGNUP_CAPTCHA: true,
});

strings.update({
    // Tempur-Pedic
    ORDER_THANK_YOU_B1_CREATE_ACCT_COPY: t`Create an account to easily check order status and get updates on delivery, plus register your products and write reviews for all your orders from one convenient location.`,
    ORDER_THANK_YOU_B1_CREATE_ACCT_SUCCESS: t`Don't forget, you can easily check order status and get updated on delivery, plus register your products and write reviews for all your orders from your <MyOrdersLink>My Orders</MyOrdersLink> page.`,
    ORDER_THANK_YOU_B3_CREATE_ACCT_COPY: t`The email address <UserEmail>EMAIL ADDRESS</UserEmail> is already associated with an account. <LoginLink>Log in</LoginLink> to easily check order status and get updates on delivery, plus register your products and write reviews for all your orders from one convenient location.`,
    ORDER_THANK_YOU_B4_CREATE_ACCT_COPY: t`Don't forget, you can easily check order status and get updates on delivery, plus register your products and write reviews for all your orders from your <MyOrdersLink>My Orders</MyOrdersLink> page.`,

    // OK - string formatted and translated in the React component
    FINANCING_MIN_AMOUNT: "750.00",
    // TODO(i18n): URL is OK as configuration, but verify this doesn't need to be locale-specific
    FINANCING_TECHNICAL_REQS_LINK:
        "https://www.wellsfargo.com/help/wfonline/hardware_software_req.jhtml",
});
